module.exports = __webpack_public_path__ + "img/Iconhoveroverview.f157a64a.svg";